<template>
  <a-modal
    :title="!isEdit ? $t('page_ops_knowledge_creat') : $t('page_ops_knowledge_edit')"
    :visible="visible"
    @cancel="cancel"
    @ok="ok"
    :width="630"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <a-form-item :label="$t('page_ops_knowledge_fault_code')">
        <a-input
          :placeholder="$t('page_ops_knowledge_enter_fault_code')"
          v-decorator="[
            'issueCode',
            {
              initialValue: editItem.issueCode,
              rules: [{ required: true, message: $t('page_ops_knowledge_enter_fault_code') }]
            }
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_knowledge_equipment_model')">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          show-search
          optionFilterProp="children"
          :placeholder="$t('page_ops_knowledge_enter_equipment_model')"
          v-decorator="[
            'deviceTypeId',
            {
              initialValue: editItem.deviceTypeId,
              rules: [{ required: true, message: $t('page_ops_knowledge_enter_equipment_model') }]
            }
          ]"
        >
          <template v-for="(item, index) in deviceTypes">
            <a-select-option :value="item.key" :key="index">
              {{ item.value }}
            </a-select-option>
          </template>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_knowledge_fault_message')">
        <a-input
          :placeholder="$t('page_ops_knowledge_enter_fault_message')"
          v-decorator="[
            'issueDesc',
            {
              initialValue: editItem.issueDesc
            }
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_knowledge_fault_type')">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          show-search
          optionFilterProp="children"
          :placeholder="$t('page_ops_knowledge_select_fault_type')"
          v-decorator="[
            'issueType',
            {
              initialValue: editItem.issueType,
              rules: [{ required: true, message: $t('page_ops_knowledge_select_fault_type') }]
            }
          ]"
        >
          <template v-for="(item, index) in issueTypes">
            <a-select-option :value="item.dictKey" :key="index">
              {{ item.dictValue }}
            </a-select-option>
          </template>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_knowledge_severity_level')">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          show-search
          optionFilterProp="children"
          :placeholder="$t('page_ops_knowledge_select_severity_level')"
          v-decorator="[
            'issueLevel',
            {
              initialValue: editItem.issueLevel,
              rules: [{ required: true, message: $t('page_ops_knowledge_select_severity_level') }]
            }
          ]"
        >
          <template v-for="(item, index) in issueLevels">
            <a-select-option :value="item.dictKey" :key="index">
              {{ item.dictValue }}
            </a-select-option>
          </template>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_knowledge_fault_source')">
        <a-input
          :placeholder="$t('page_ops_knowledge_enter_fault_source')"
          v-decorator="[
            'issueSource',
            {
              initialValue: editItem.issueSource
            }
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_knowledge_cause_of_failure')">
        <a-input
          :placeholder="$t('page_ops_knowledge_enter_cause_of_failure')"
          v-decorator="[
            'causedBy',
            {
              initialValue: editItem.causedBy
            }
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_knowledge_treatment_measures')">
        <text-edit
          :content="contentHtml"
          v-if="visible"
          v-decorator="[
            'solution',
            {
              initialValue: editItem.solution
            }
          ]"
          @change="(value) => changeValue(value)"
        ></text-edit>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { KnowledgeLibraryServiceProxy } from '@/service-proxies/app-v2/knowledge-library.service-proxies'

const klsp = new KnowledgeLibraryServiceProxy()
const dtsp = new DeviceTypeServiceProxy()
const dbsp = new DictServiceProxy()

import TextEdit from './TextEdit.vue'

export default {
  components: {
    TextEdit
  },
  props: {
    issueTypes: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    editItem: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: {
      handler() {
        this.deviceTypes = []
        this.issueLevels = []
        this.getTypeList()
        this.getDictionary()
        if (JSON.stringify(this.editItem) !== '{}') {
          console.log(this.editItem.solution)
          this.contentHtml = this.editItem.solution ? this.editItem.solution : ''
        } else {
          this.contentHtml = ''
        }
        console.log(this.contentHtml)
      }
    }
  },
  data() {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this),
      contentHtml: '',
      deviceTypes: [],
      issueLevels: []
    }
  },
  methods: {
    async getTypeList() {
      const filter = {
        keywords: '',
        query: {
          current: 1,
          size: -1
        }
      }
      const type = await dtsp.pageDeviceType(filter)
      const list = type.records.map((res) => {
        return { key: res.id, value: res.name }
      })
      this.deviceTypes = this.deviceTypes.concat(list)
    },
    async getDictionary() {
      const issueLevels = await dbsp.dictionary('issue-level')
      this.issueLevels = issueLevels.data
    },
    cancel() {
      this.form.resetFields()
      this.contentHtml = ''
      this.$emit('close', false)
    },
    ok() {
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(values)
          this.confirmLoading = true
          if (this.isEdit) {
            values.id = this.editItem.id
          }
          setTimeout(() => {
            this.confirmLoading = false
          }, 300)
          klsp.submitKnowledgeLibrary(values).then(() => {
            if (!this.isEdit) {
              this.$message.success(this.$t('page_ops_knowledge_add_success'))
            } else {
              this.$message.success(this.$t('page_ops_knowledge_edit_success'))
            }
            this.form.resetFields()
            this.contentHtml = ''
            this.$emit('close', true)
          })
        }
      })
    },
    changeValue(value) {
      this.contentHtml = value
    }
  }
}
</script>

<style lang="scss" scoped></style>
